import React, { useState } from "react";
import {Button,  FormControl, InputLabel, MenuItem, TableRow, Table, TableHead,
     TableBody, TableCell,
    TableContainer,
          Paper,} from "@material-ui/core";
import ExportExcel from "../../Excelexport";
import AttendenceService from "./Locality/Service/attendenceService";
import AddClassService from "./Locality/Service/addClassService";
import SectionService from "./Locality/Service/sectionService";
import { Grid, Card, Box, Select, TextField } from "@material-ui/core";
import {  useEffect } from 'react';
import StudentService from "./Locality/Service/studentService";
import TablePagination from '@material-ui/core/TablePagination';
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import { withStyles, makeStyles } from '@material-ui/core/styles';
const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#0f3b62ad",
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);
const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
}));
export default function Reports() {

    const tableHeaders = [ 'Student Name', 'Number Of Working Days','Days Present','Days Absent'];
    const classes = useStyles();
    const [result, setResult]= useState([]);
    const [reportList, setReportList] = useState([]);
    const [pg, setpg] = React.useState(0);
    const [rpg, setrpg] = React.useState(1000);
    const [startDate1, setStartDate1] = useState('');
    const [endDate1, setEndDate1] = useState('');
    const [age, setAge] = React.useState('');
    var [studentId, setStudentId] = useState("");
    var [classId, setClassId] = useState("");
    const [sectionId, setSectionId] = useState("");
    const [sectionList, setSectionList] = useState([]);
    const [studentList, setStudentList] = useState([]);
    const [getReport, setGetReport ]= useState([]);
    const [open, setOpen] = React.useState(false);
    const [addClassList, setAddClassList] = useState([]);
    const current = new Date();
    const date = `${current.getFullYear()}-0${current.getMonth() + 1}-${current.getDate()}`;
    const [activity, setActivity] = useState({
        classId: '',
        startDate: '',
        endDate: '',
        description: '',
        activityName: '',
        status: '',
    });
    const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
    
    useEffect(() => {
        // getStudentList();
        getAddClassList();
        return () => {
            setReportList([]);
            setStudentList([]);
            setGetReport([]);
        }
    }, []);
    const handleChangeRowsPerPage=(event)=> {
        setrpg(parseInt(event.target.value, 10));
        setpg(0);
    }
    const getSectionListByClass = (selectedClassId) => {
        if (!selectedClassId) {
            setSectionList([]);
            setSectionId("");
            return;
        }
        SectionService.findSectionList({
            schooleId: userDetails.schooleId,
            classId: selectedClassId,
        })
            .then((res) => {
                let list = Array.isArray(res) ? res : [];
                // if (userDetails.role === "TEACHER" && userDetails.sectionId) {
                //     list = list.filter(
                //         (s) => String(s._id) === String(userDetails.sectionId)
                //     );
                // }
                setSectionList(list);
                // if (userDetails.role === "TEACHER" && userDetails.sectionId && list.length > 0) {
                //     setSectionId(userDetails.sectionId);
                // }
            })
            .catch(() => {
                setSectionList([]);
            });
    };

    const getAddClassList = () => {
        AddClassService.getAllAddClass(userDetails.schooleId).then((res) => {
            let list = res;
            if (userDetails.role === "TEACHER" && userDetails.classId) {
                list = res.filter(item => item._id === userDetails.classId);
            }
            setAddClassList(list);
            if (list.length > 0) {
                const initialClassId = userDetails.role === "TEACHER" && userDetails.classId
                    ? userDetails.classId
                    : list[0]._id;
                setClassId(initialClassId);
                const initialSectionId = userDetails.role === "TEACHER" ? (userDetails.sectionId || "") : "";
                setSectionId(initialSectionId);
                getSectionListByClass(initialClassId);
                getStudentList({ target: { value: initialClassId } }, initialSectionId || undefined);
                onSubmit();
            }

        }).catch((err) => {
            // setError(err.message);
        });
    }
    const  excelExport  =(res)  => {
        const result= res.map((response)=>{
 
             return {
              
                 "Student Name":response.studentName, 
                 "Count":response.count,
                 "Date":response.present,
                 "Absent":response.absent 
             }
            
          })
          setResult(result);
     };
    const onSubmit = data => {
        const report = JSON.parse(localStorage.getItem("userDetail"));
        let newstartDate1 = startDate1 ? startDate1 : null;
        const newendDate1 = endDate1 ? endDate1 : null;
        // if(newstartDate1){
        //     const prior = new Date().setDate(new Date(startDate1).getDate() - 1);
        //     console.log(new Date(prior).toISOString())
        //     newstartDate1 =  new Date(prior).toISOString();
        // }
    
        const keys = {
            "schooleId": report.schoolId,
            "studentId": studentId,
            "startDate1": newstartDate1,
            "endDate1": newendDate1,
            "classId": classId,
            "sectionId": sectionId || userDetails.sectionId || undefined,
        }
        AttendenceService.getStuAttReport(keys).then((res) => {
            excelExport(res);
            setGetReport(res);
            
        }).catch((err) => {
        });
    };
    const getStudentList = (event, overrideSectionId) => {
        const selectedClassId = (event && event.target) ? event.target.value : classId;
        if (!selectedClassId) return;

        const body = { classId: selectedClassId };
        const effectiveSectionId =
            overrideSectionId !== undefined
                ? overrideSectionId
                : (sectionId || userDetails.sectionId || undefined);
        if (effectiveSectionId) {
            body.sectionId = effectiveSectionId;
        }

        setClassId(selectedClassId);
        StudentService.getAllStudentById(userDetails.schooleId, body
        ).then((res) => {
            
            const studentDetails = res.map(res => {
                return { _id: res._id, studentName: `${res.firstName} ${res.lastName}`, status: true };
            });
            
            setStudentList(studentDetails);
        }).catch((err) => {
            // setError(err.message);
        });
    }

    // const getStudentList = (event, obj) => {
    //     const userDetails = JSON.parse(localStorage.getItem("userDetail"));
    //     StudentService.getAllStudentById(userDetails.schooleId,

    //     ).then((res) => {
    //         const studentDetails = res.map(res => {
    //             return { _id: res._id, studentName: `${res.firstName} ${res.lastName}`, status: true };
    //         })
    //         setStudentList(studentDetails);

    //         if (obj) {
    //             setActivity(obj);
    //         }
    //     }).catch((err) => {
    //         // setError(err.message);
    //     });
    // }
   
    const handleChangePage=(event, newpage) =>{
        setpg(newpage);
    }

    return (

        <>
            <PageTitle title="Attendance Reports" />
            <Card sx={{ maxWidth: '100%' }}>
                <Box style={{ margin: 15 }}>
                    <div>
                             <Grid container spacing={2} columns={12}>
                             <Grid item xs={6} sm={4} md={2} >
                             <FormControl className={classes.formControl}  style={{ width: 170 }}
                                        >
                                            <InputLabel id="demo-simple-select-label">Select Class</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                name="classId"
                                                label="selectClass"
                                              
                                                onChange={e => {
                                                    const selected = e.target.value;
                                                    setClassId(selected);
                                                    setSectionId("");
                                                    getSectionListByClass(selected);
                                                    getStudentList(e, undefined);
                                                }}
                                                value={classId}
                                            >
                                                <MenuItem value="">
                                                    <em>None</em>
                                                </MenuItem>

                                                {addClassList.map(({ _id, className }) => (
                                    <MenuItem key={_id} value={_id}>{className}
                                        
                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                        </Grid>
                             <Grid item xs={6} sm={4} md={2} >
                                <FormControl className={classes.formControl} style={{ width: 170 }}>
                                    <InputLabel id="section-select-label">Select Section (Optional)</InputLabel>
                                    <Select
                                        labelId="section-select-label"
                                        id="section-select"
                                        value={sectionId}
                                        onChange={(e) => {
                                            const newSectionId = e.target.value;
                                            setSectionId(newSectionId);
                                            if (classId) {
                                                getStudentList({ target: { value: classId } }, newSectionId || undefined);
                                            }
                                        }}
                                        disabled={!classId || sectionList.length === 0}
                                    >
                                        <MenuItem value="">
                                            <em>None</em>
                                        </MenuItem>
                                        {sectionList.map(({ _id, sectionName }) => (
                                            <MenuItem key={_id} value={_id}>
                                                {sectionName}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                             </Grid>
                             <Grid item xs={6} sm={4} md={2} >
                             <FormControl variant="standard" fullWidth>
                            <InputLabel id="studentName">Student Name</InputLabel>
                            <Select
                                labelId="studentName"
                                id="studentName"
                                label="Student Name"
                                name="studentId"
                                 value={studentId}
                                onChange={e => {setStudentId(e.target.value) }}
                                // error={formik.touched.studentId && Boolean(formik.errors.studentId)}
                                // helperText={formik.touched.studentId && formik.errors.studentId}
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                {studentList.map(({index,_id, studentName}) => (
                                    <MenuItem key={index} value={_id}>{studentName}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                                </Grid>
                            <Grid item xs={6} sm={4} md={2}>
                                    <form className={classes.container} noValidate>
                                    <TextField InputProps={{ style: { width: 150 } }}
                                            id="dob"
                                            name="dob"
                                            label="Start Date"
                                            type="date"
                                        
                                            value={startDate1}
                                            onChange={e => {getStudentList(e.target.value); setStartDate1(e.target.value) }}          
                                            className={classes.textField}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </form>
                                </Grid>
                                <Grid item xs={6} sm={6} md={2} >
                                <TextField InputProps={{ style: { width: 120 } }}
                                            id="dob"
                                            name="dob"
                                            label="End Date"
                                            type="date"
                                           min="2016-11-10"
                                            max="2022-11-10" 
                                            value={endDate1}
                                            onChange={e => {setEndDate1(e.target.value) }}
                                            // defaultValue="2017-05-24"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                </Grid>
                                <Grid item xs={6} sm={4} md={1} style={{ display: 'flex', alignItems: 'flex-end' }}>
                                <Button style={{ backgroundColor: 'rgb(15 59 98)', color: 'white', whiteSpace: 'nowrap' }}
                                 type="button" onClick={() => onSubmit()} variant="contained" >
                                     Search</Button>
                                </Grid>
                                <Grid item xs={6} sm={4} md={1} style={{ display: 'flex', alignItems: 'flex-end' }}>
                                <ExportExcel excelData={result} fileName={'Student Activity'} />
                                </Grid>
                            </Grid>
                            
                </div>  
                </Box>
            </Card>
            <br></br>
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Widget title="" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
                                                                        <TableContainer component={Paper} style={{ maxHeight: 500 }}>
                        
                        <Table stickyHeader className="mb-0">
                            <TableHead >
                                <TableRow>
                                    {tableHeaders.map(key => (
                                        <StyledTableCell key={key}>{key}</StyledTableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                           
                                {getReport.slice(pg * rpg, pg * rpg + rpg).map((report) => (
                                    <TableRow key={report._id}>

                                       {/* <TableCell className="pl-3 fw-normal" >{report.classId ? report.classId.className : ''}</TableCell> */}

                                     <TableCell className="pl-3 fw-normal" >{report.studentName}</TableCell>
                                     <TableCell className="pl-3 fw-normal" >{report.count}</TableCell>
                                        <TableCell className="pl-3 fw-normal" >{report.present}</TableCell>
                                        <TableCell className="pl-3 fw-normal" >{report.absent}</TableCell>
                                       
                                    </TableRow>
                                    
                                ))}
                                {/* ))} */}
                            </TableBody>
                        </Table>
                                    </TableContainer >
                        <TablePagination
                            component="div"
                            rowsPerPageOptions={[ 1000, 10000, 100000 ]}
                            count={reportList.length}
                            page={pg}
                            onPageChange={handleChangePage}
                            rowsPerPage={rpg}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Widget>
                </Grid>
            </Grid>
        </>
    );
}


